export const ARTISTS = [
  {
    name: "MIA MI",
    image: "/assets/images/mia.jpg",
    description: "Leif is a soulful-based electronic synth pop artist who specializes in four tracks and ready hits"
  },
  {
    name: "LEIF COEFIELD",
    image: "/assets/images/leif.jpg",
    description: "Leif is a touring, touring drummer/singer, multi artist who communicates both in social connection"
  }
];

export const SUPPORTERS = [
  "Youth Music",
  "National Fund for Youth Music",
  "Help Musicians",
  "PRS Foundation"
];